import { useState, type DragEvent } from 'react';
import { uploadChatFile } from '@/lib/chat-files';
import type { ChatSource } from '@shared/types/chat-sources';

/**
 * D4 — files dropped on the chat composer: each is sent to « Fichiers du
 * chat » and becomes a cited source as soon as it is read.
 */
export const useChatFileDrop = (addSource: (source: ChatSource) => void) => {
  const [uploading, setUploading] = useState<string[]>([]);
  const [dragging, setDragging] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const send = async (files: File[]) => {
    setError(null);
    for (const file of files) {
      setUploading((current) => [...current, file.name]);
      try {
        addSource(await uploadChatFile(file));
      } catch (reason) {
        setError(`${file.name} : ${reason instanceof Error ? reason.message : 'envoi impossible.'}`);
      } finally {
        setUploading((current) => current.filter((name) => name !== file.name));
      }
    }
  };

  const dropProps = {
    onDragOver: (event: DragEvent) => {
      if (!event.dataTransfer.types.includes('Files')) return;
      event.preventDefault();
      setDragging(true);
    },
    onDragLeave: () => setDragging(false),
    onDrop: (event: DragEvent) => {
      if (!event.dataTransfer.files.length) return;
      event.preventDefault();
      setDragging(false);
      void send([...event.dataTransfer.files]);
    },
  };

  return { uploading, dragging, error, dropProps, send };
};
